import React from 'react';
import { useWidgetsTheme as theme } from '@src/core/hooks';
import Login from '@src/features/customers/auth/legacy/Login';
import Signup from '@src/features/customers/auth/legacy/Signup';
import ForgotPassword from '@src/features/customers/auth/legacy/password-recovery/ForgotPassword';
import { Spinner } from '@src/components/reusable';
import styled from 'styled-components';
import { useAuthFlow } from '@src/features/customers/auth/hooks/useAuthFlow';
import { AUTH_MODE } from '@src/domains/customers';

export const LOGIN = AUTH_MODE.LOGIN;
export const SIGNUP = AUTH_MODE.SIGNUP;
export const FORGOT_PASSWORD = AUTH_MODE.FORGOT_PASSWORD;

export type CurrentModePageTypes = 'checkout' | 'account';

interface AuthDisplayProps {
  onLogin?: () => void;
  hasBackAction?: boolean;
}

const AuthDisplay = (props: AuthDisplayProps) => {
  const { onLogin, hasBackAction = false } = props;
  const actionColor = theme('actionColor');

  const { mode, setMode, loading } = useAuthFlow(onLogin);

  if (loading) {
    return (
      <SpinnerWrapper>
        <Spinner visible spinnerColor={actionColor} />
      </SpinnerWrapper>
    );
  }

  return (
    <div>
      <div>
        {(() => {
          switch (mode) {
            case LOGIN:
              return <Login setMode={setMode} hasBackAction={hasBackAction} />;
            case FORGOT_PASSWORD:
              return <ForgotPassword onBack={() => setMode(LOGIN)} />;
            case SIGNUP:
              return <Signup setMode={setMode} />;
            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
};

const SpinnerWrapper = styled.div`
  width: 100px;
  height: 100px;
  margin: 0 auto;
`;

export default AuthDisplay;
